/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HealthGoalResponseDto } from './HealthGoalResponseDto';
import {
    HealthGoalResponseDtoFromJSON,
    HealthGoalResponseDtoFromJSONTyped,
    HealthGoalResponseDtoToJSON,
    HealthGoalResponseDtoToJSONTyped,
} from './HealthGoalResponseDto';

/**
 * 
 * @export
 * @interface GoalsOfTreatmentResponseDto
 */
export interface GoalsOfTreatmentResponseDto {
    /**
     * Patient identity
     * @type {string}
     * @memberof GoalsOfTreatmentResponseDto
     */
    patientId: string;
    /**
     * The top 3 things the user would like to change about their health
     * @type {Array<HealthGoalResponseDto>}
     * @memberof GoalsOfTreatmentResponseDto
     */
    healthGoals: Array<HealthGoalResponseDto>;
    /**
     * The patient's long-term goal. Absent if the patient has no long-term goal.
     * @type {HealthGoalResponseDto}
     * @memberof GoalsOfTreatmentResponseDto
     */
    longTermGoal?: HealthGoalResponseDto;
    /**
     * Last updated timestamp
     * @type {string}
     * @memberof GoalsOfTreatmentResponseDto
     */
    lastUpdated: string;
}

/**
 * Check if a given object implements the GoalsOfTreatmentResponseDto interface.
 */
export function instanceOfGoalsOfTreatmentResponseDto(value: object): value is GoalsOfTreatmentResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('healthGoals' in value) || value['healthGoals'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    return true;
}

export function GoalsOfTreatmentResponseDtoFromJSON(json: any): GoalsOfTreatmentResponseDto {
    return GoalsOfTreatmentResponseDtoFromJSONTyped(json, false);
}

export function GoalsOfTreatmentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoalsOfTreatmentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'healthGoals': ((json['healthGoals'] as Array<any>).map(HealthGoalResponseDtoFromJSON)),
        'longTermGoal': json['longTermGoal'] == null ? undefined : HealthGoalResponseDtoFromJSON(json['longTermGoal']),
        'lastUpdated': json['lastUpdated'],
    };
}

export function GoalsOfTreatmentResponseDtoToJSON(json: any): GoalsOfTreatmentResponseDto {
    return GoalsOfTreatmentResponseDtoToJSONTyped(json, false);
}

export function GoalsOfTreatmentResponseDtoToJSONTyped(value?: GoalsOfTreatmentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'healthGoals': ((value['healthGoals'] as Array<any>).map(HealthGoalResponseDtoToJSON)),
        'longTermGoal': HealthGoalResponseDtoToJSON(value['longTermGoal']),
        'lastUpdated': value['lastUpdated'],
    };
}

